var winWidth = $(window).width()
const navSwitch = 1024

if (!$('.nav--main > .nav--meta').length) {
	const metaNavClone = $('.nav--meta > ul').clone().addClass('nav--meta')
	$('.nav--main').append(metaNavClone)
}

var resizeTimer

$(window).on('resize', function (e) {
	clearTimeout(resizeTimer)
	resizeTimer = setTimeout(function () {
		winWidth = $(window).width()
		if (winWidth > navSwitch) {
			$('body').removeClass('mobilenav--isvisible')
		}
	}, 250)
})

$('.nav--main > ul li.has-sub').each(function (index, el) {
	var $sourceLink = $('> a', this)
	var $targetList = $('ul:first', this)

	if ($targetList.find('> .nav__back-item, > .nav__back').length) {
		return
	}

	var linkText = $.trim($sourceLink.text())
	var lvlLink = $sourceLink.clone().addClass('mobile-only nav__back')
	var backLabel = $('<span class="nav__back-label">Zurück</span>')
	var currentLabel = $('<span class="nav__back-current"></span>').text(linkText)

	lvlLink.empty().append(backLabel).append(currentLabel)

	if ($('img', $sourceLink).length) {
		lvlLink.addClass('has-img')
	}

	$targetList.prepend(lvlLink)
})

$('.nav--main  ul li.has-sub > a').click(function (e) {
	if (winWidth < navSwitch) {
		e.preventDefault()
		var currentLi = $(this).parent()

		if ($('.nav--main').hasClass('nav--main--lvl-2')) {
			$(currentLi).addClass('lvl-3')
			$('.nav--main').addClass('nav--main--lvl-3')
		} else {
			$(currentLi).addClass('lvl-2')
			$('.nav--main').addClass('nav--main--lvl-2')
		}

		$('.nav--main__container').animate(
			{
				scrollTop: 0,
			},
			50
		)
	}
})

$('.nav-toggle').click(function (event) {
	$('.nav--main ul li').removeClass('lvl-2 lvl-3')
	$('.nav--main').removeClass('nav--main--lvl-2  nav--main--lvl-3')
})

$('.nav__back').click(function (e) {
	e.preventDefault()
	if ($('.nav--main').hasClass('nav--main--lvl-3')) {
		$('.nav--main > ul > li').removeClass('lvl-3')
		$('.nav--main').removeClass('nav--main--lvl-3')
	} else {
		$('.nav--main > ul > li').removeClass('lvl-2')
		$('.nav--main').removeClass('nav--main--lvl-2')
	}

	$('.nav--main__container').animate(
		{
			scrollTop: 0,
		},
		50
	)
})
